//ROUTES 
let API_ROUTE = {
    BLOG_LIST: '/blog/list',
    CONTACT_ADD: '/contact/add',
};

module.exports = Object.freeze({
    API_ROUTE,
});